import script from "./NAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./NAvatar.vue?vue&type=script&setup=true&lang=js"

import "./NAvatar.vue?vue&type=style&index=0&id=244f9dbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244f9dbf"]])

export default __exports__